
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/gurutto-ai",
      function () {
        return require("private-next-pages/cases/gurutto-ai/index.tsx");
      }
    ]);
  